import React, { useMemo, useState } from 'react';
import { Box, Accordion, AccordionSummary, AccordionDetails, Typography, Grid2, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CustomDivider from '../../shared/utils/CustomDivider';
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent';
import { useCourseApartmentDetail, useCourseList, useStudentCourseNameList } from '../../assets/api/useAdminApi';
import CourseTableList from './CourseTableList';
import CourseLinkForm from './CourseLinkForm';
import SearchInput from '../../shared/components/student/SearchInput';
import { FilterButton, StatusButton } from '../../shared/utils/IconButton';
import { Constants } from '../../shared/constants';
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox';
import { useDialog } from '../../shared/hook/useDialog';
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';
import ToggleSwitch from '../../shared/utils/CustomToggle';
const CourseList = () => {
    const [selectedCategory, setSelectedCategory] = useState('');
    const [courseId, setCourseId] = React.useState(null);
    const [expandedPanel, setExpandedPanel] = React.useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [showActiveOnly, setShowActiveOnly] = useState(true);
    const { open, handleClickOpen, handleClose } = useDialog();
    const { data: courseList, isLoading } = useCourseList();
    const { data: courseApartmentDetail, isLoading: isCourseApartmentLoading } = useCourseApartmentDetail({ course_id: courseId });
    const handleAccordionChange = (panelId) => (event, isExpanded) => {
        setExpandedPanel(isExpanded ? panelId : null);
        setCourseId(isExpanded ? panelId : null);
    };
    const originalCourseRows = useMemo(() => {
        return courseApartmentDetail?.map((item, index) => ({
            sr_no: index + 1,
            ...item
        })) || [];
    }, [courseApartmentDetail]);

    // // Filter cities based on search query
    // const filteredCourseRows = useMemo(() => {
    //     if (!searchQuery.trim()) {
    //         return originalCourseRows;
    //     }
    //     const lowercasedQuery = searchQuery.toLowerCase();
    //     return originalCourseRows.filter(city =>
    //         city?.apartment_name?.toString().toLowerCase().includes(lowercasedQuery)
    //     );
    // }, [originalCourseRows, searchQuery]);

    const filteredCourseRows = useMemo(() => {
        if (!searchQuery.trim()) return originalCourseRows;
        const lowercasedQuery = searchQuery.toLowerCase();
        return originalCourseRows.filter(item =>
            item?.apartment_name?.toLowerCase().includes(lowercasedQuery)
        );
    }, [originalCourseRows, searchQuery]);

    const filteredCourseList = useMemo(() => {
        if (!courseList?.data) return [];
        let rows = courseList.data;
        if (selectedCategory) {
            rows = rows.filter(course => course.category_name === selectedCategory);
        }
        if (showActiveOnly) {
            rows = rows.filter(course => course.status === 1); 
        }
        return rows;
    }, [courseList, selectedCategory, showActiveOnly]);

    const handleSearchChange = (value) => {
        setSearchQuery(value);
    };

    // const categoryOptions = Array.from(
    //     new Set(courseList?.data?.map(item => item.name))
    // ).map(name => ({
    //     value: name,
    //     label: name
    // }));

    const categoryOptions = Array.from(
        new Set(courseList?.data?.map(item => item.category_name).filter(Boolean))
    ).map((name, index) => ({
        id: index + 1,
        value: name,
        label: name,
    }));


    const initialValues = {
        category_name: "",
    };

    const validationSchema = Yup.object().shape({});
    const handleSubmit = (values, { resetForm }) => {
        setSelectedCategory(values.category_name);
        handleClose();
        resetForm();
    };

    const handleToggleChange = (isChecked) => {
        setShowActiveOnly(isChecked);
    };
    return (
        <Box>
            <CustomDivider />

            <NormalContainerWithHeader headerText={"Assign Courses"} >
                <CourseLinkForm />
            </NormalContainerWithHeader>
            <CustomDivider orientation='horizontal' />
            <NormalContainerWithHeader headerText={"Course List"} RightContent={
                <Box sx={{ gap: 4, display: 'flex', alignItems: 'center' }}>

                    <ToggleSwitch checked={showActiveOnly} onCheck={handleToggleChange} checkedText="Active" unCheckedText="Active" />
                    <FilterButton
                        bgcolor={"transparent"}
                        border={"0.5px solid #A9B7FD"}
                        src={Constants.customImages.FilterDark}
                        onClick={handleClickOpen}
                    />

                </Box>

            } >

                <CustomDivider orientation='horizontal' />
                {

                    !isLoading && filteredCourseList?.map((item) => (
                        <Accordion
                            key={item?.id}
                            expanded={expandedPanel === item?.id}
                            onChange={handleAccordionChange(item?.id)}
                            sx={{ boxShadow: "none", border: "none" }}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", mr: 2 }}>
                                    <Typography variant='body2' sx={{ display: "flex", alignItems: "center", gap: 1 }}>{item?.title}</Typography>
                                    <StatusButton status={item?.status} />
                                </Box>

                            </AccordionSummary>
                            {expandedPanel === item?.id && (
                                <AccordionDetails>
                                    <Box width={{ xs: "80%", md: "40%" }} marginLeft={"auto"} marginBottom={2}>
                                        <SearchInput onChange={handleSearchChange} placeholder={"Search By Apartment Name"} />
                                    </Box>
                                    <CourseTableList courseRow={filteredCourseRows} isLoading={isCourseApartmentLoading} />
                                </AccordionDetails>
                            )}

                            {/* <AccordionDetails>
                                <Box width={{xs:"80%",md:"40%"}} marginLeft={"auto"} marginBottom={2}>
                                    <SearchInput onChange={handleSearchChange} placeholder={"Search By Apartment Name"} />
                                </Box>
                                <CourseTableList courseRow={filteredCourseRows} isLoading={isCourseApartmentLoading} />
                            </AccordionDetails> */}
                        </Accordion>
                    ))}

                {
                    isLoading && [...Array(10)].map((_, index) => (
                        <Box key={index}>
                            <SkeletonCom height={"30px"} style={{ margin: "5px" }} />
                        </Box>
                    ))

                }
            </NormalContainerWithHeader>
            <MainDialogBox open={open} handleClose={handleClose} width={"30%"} heading={"Filter Event"}>
                <Formik initialValues={initialValues} enableReinitialize validationSchema={validationSchema} onSubmit={handleSubmit}>
                    {() => (
                        <Form>
                            <Grid2 container spacing={"20px"}>
                                <Grid2 children size={12}>
                                    <Field
                                        name="category_name"
                                        component={AutoCompleteField}
                                        placeholder="Select Category"
                                        options={categoryOptions}
                                        label="select Category"
                                        isLoading={isLoading}
                                    />
                                </Grid2>

                                <Grid2 children textAlign={"end"} size={12}>
                                    <Button variant='contained' type='submit' fullWidth>Filter</Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </MainDialogBox>
        </Box>
    );
};

export default CourseList;
